import { Tag, Typography } from "antd";
import { SALE_CHANNEL_EMPTY_TEXT, getSaleChannelColor, sortSaleChannels } from "pages/App/Product/constants";
import "./index.scss";

// Tag kênh bán chỉ để hiển thị: outline, size small, tự wrap, không "+n", không click, không tooltip.
// Thứ tự và màu theo R17 (SALE_CHANNEL_DISPLAY).
const SaleChannelTags = ({ channels, className = "" }) => {
  const sorted = sortSaleChannels(channels);

  if (sorted.length === 0) {
    return (
      <Typography.Text type="secondary" italic className="sale-channel-tags-empty">
        {SALE_CHANNEL_EMPTY_TEXT}
      </Typography.Text>
    );
  }

  return (
    <div className={`sale-channel-tags ${className}`.trim()}>
      {sorted.map((channel) => (
        <Tag key={channel.id} color={getSaleChannelColor(channel)} className="sale-channel-tag">
          {channel.name}
        </Tag>
      ))}
    </div>
  );
};

export default SaleChannelTags;
